import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  HostBinding,
  HostListener,
  input,
} from '@angular/core';
import { Size } from '../common/types';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  standalone: true,
  imports: [CommonModule, Icon],
})
export class ProfileImage {
  src = input<string>('');
  size = input<Size>('md');

  @HostBinding('class') get hostClass() {
    if (this.src()) {
      return 'cursor-pointer';
    }

    return '';
  }

  @HostListener('click') handleClick() {
    if (this.src()) {
      window.open(this.src(), '_blank');
    }
  }

  currentSize = computed(() => {
    switch (this.size()) {
      case 'sm':
        return 'size-8 min-w-8';
      case 'md':
        return 'size-10 min-w-10';
      case 'lg':
        return 'size-20 min-w-20';
      case 'xl':
        return 'size-24 min-w-24';
      default:
        return 'size-10 min-w-10';
    }
  });
}
